'use strict';

var $ = require('jquery');
var ItemFilterManager = require('../lib/ItemFilterManager.js');
var setupFilters = require('./setupFilters.js');
var ViewportTracker = require('../lib/ViewportTracker.js');
var getAbsoluteUrl = require('../lib/getAbsoluteUrl.js');
var toggleBodyScrollbar = require('../lib/toggleBodyScrollbar.js');
var triggerEvent = require('../lib/triggerEvent.js');
var detectBrowser = require('../lib/detectBrowser.js');

var Modal = require('../lib/Modal.js');
var StateManager = require('../lib/StateManager.js');
var StateHolder = StateManager.StateHolder;


function setupFilterInterface() {
	//*DEBUG*/console.log('setupFilterInterface');

	var $filtersArea = $('.filters');
	if ($filtersArea.length === 0)
		return;

	setupFilters('filters');

	var $filterOptions = $('input', $filtersArea);
	var $products = $('.swatch');

	var config = {
		filterItemSelector: '.filter__item',
		filtersOnClass: 'filters--hasSelected',
		selectedClass: 'filter__item--selected',
		noMatchesRemainClass: 'filter__item--noMatchesRemain',
		notMatchClass: 'swatch--notMatchFilters',
		onUpdate: function() {
			$(window).trigger('swatchesFiltered');
		}
	};
	new ItemFilterManager($filtersArea, $filterOptions, $products, config);


	var modal = new Modal('m', {
		className: 'modal modal--helpMeChoose',
		width: 940,
		height: null,
		maxWidth: '90%',
		maxHeight: '90%',
		html: function() {
			var currColorboxSettings = $.colorbox.element().data('colorbox');
			var anchor = document.getElementById(currColorboxSettings.id);
			if (anchor === null)
				return null;

			var $content = $('#' + anchor.getAttribute('data-contentref'));
			return $content.html();
		}
	});

	$('.filter__helpMeChoose').on('click', function(event) {
		event.preventDefault();
		modal.open({id: this.id});
	});
}

function setupSelectSwatch() {
	//*DEBUG*/console.log('setupSelectSwatch');

	var $swatches = $('.swatch');
	var $swatchesArea = $('.swatches');

	/* =========================================================================================
	 * CurrentSwatch
	 */
	function CurrentSwatch() {
		//*DEBUG*/console.log('CurrentSwatch');
		StateHolder.call(this, 's');

		this.currentSwatchId = undefined;
		this.swatchIdToData = {};
		for (var index = 0; index < $swatches.length; index++) {
			var swatch = $swatches.get(index);
			this.swatchIdToData[swatch.id] = {
				index: index
			};
		}
	}
	CurrentSwatch.prototype = Object.create(StateHolder.prototype);
	CurrentSwatch.prototype.createProductLineURLForSwatchId = function(swatchId, lineData) {
		//*DEBUG*/console.log('CurrentSwatch: createProductLineURLForSwatchId');
		if (lineData === undefined) {
			var activeSwatchData = this.swatchIdToData[swatchId];
			var $activeSwatch = $swatches.eq(activeSwatchData.index);
			var lineId = $activeSwatch.attr('data-lineid');
			lineData = window.lineData[lineId];
		}
		return getAbsoluteUrl(lineData.href + '?s.id=' + encodeURIComponent(swatchId));
	}
	CurrentSwatch.prototype.loaded = function() {
		//*DEBUG*/console.log('CurrentSwatch: loaded');
		var newSwatchId = this.state.id;

		if (newSwatchId === this.currentSwatchId) {
			return;
		}

		this.removeIsActiveClasses();

		if (newSwatchId !== undefined) {
			this.currentSwatchId = newSwatchId;
			var activeSwatchData = this.swatchIdToData[this.currentSwatchId];
			var $activeSwatch = $swatches.eq(activeSwatchData.index);

			$activeSwatch.addClass('isActive');
		} else {
			this.removeIsActiveClasses();
			this.currentSwatchId = undefined;
		}
	}
	CurrentSwatch.prototype.removeIsActiveClasses = function() {
		//*DEBUG*/console.log('CurrentSwatch: removeIsActiveClasses');
		$swatches.removeClass('isActive');
	}
	CurrentSwatch.prototype.switchTo = function(id, save, refresh) {
		//*DEBUG*/console.log('CurrentSwatch: switchTo');
		if (save === undefined)
			save = true;
		if (refresh === undefined)
			refresh = true;

		this.state.id = id;

		if (save) {
			StateManager.instance.save(refresh);
		}
	}

	var currentSwatch = new CurrentSwatch();

	/* =========================================================================================
	 * Select/click on swatches
	 */
	/* 2025-05-24: Removed cause it actually creates another entry in the browser history.. have to click back a lot.
	$swatchesArea.on('click', '.swatch', function(e) {
		e.preventDefault();
		currentSwatch.switchTo(this.id);
	});
	*/

	// Now that we are completely setup we can add the StateHandler to the StateManager, allowing it
	// to restore any current state and manage any future states.
	StateManager.instance.add(currentSwatch);

	return currentSwatch;
}

function setupProductLine(currentSwatch) {
	//*DEBUG*/console.log('setupProductLine',currentSwatch);
	var browserInfo = detectBrowser.getInfo();
	var isOSSafari = browserInfo.isOSSafari;

	var $productLineModal = $(
			'<div class="productLineModal">'+
				'<div class="productLineModal__overlay"></div>'+
				'<a href="#" class="productLineModal__returnToResults returnToResults"><span>Return to Results</span></a>'+
				'<div class="productLineModal__container">'+
					'<div class="productLineModal__loader"></div>'+
					'<iframe class="productLineModal__body" aria-hidden="true" tabindex="-1"'
						+ (isOSSafari?' scrolling="no"':'') +
					'/>'+
				'</div>'+
			'</div>'
	);
	$('body').append($productLineModal);
	var $productLineModal__body = $productLineModal.find('.productLineModal__body');
	var iframe = $productLineModal__body.get(0);

	// On iframe loading add class
	var productLineSelected = undefined;
	$productLineModal__body.on('load', function() {
		if (productLineSelected !== undefined) {
			$productLineModal.addClass('productLineModal--loaded');

			iframe.contentWindow.document.querySelector('body').className += ' page--loadedAndInPlace';

			// For accessibility
			iframe.removeAttribute('aria-hidden');
			iframe.removeAttribute('tabindex');
			iframe.setAttribute('title', iframe.contentWindow.document.querySelector('h1').textContent);
		}
	});


	function ProductLineStateHolder() {
		//*DEBUG*/console.log('ProductLineStateHolder');
		StateHolder.call(this, 'p');
		StateManager.instance.add(this);
	}
	ProductLineStateHolder.prototype = Object.create(StateHolder.prototype);
	ProductLineStateHolder.prototype.hasModalSlideIn = false;
	ProductLineStateHolder.prototype.getStateTitle = function() {
		//*DEBUG*/console.log('ProductLineStateHolder: getStateTitle');
		// We do not want this to be treated as part of a potential GA pageView
		// We do not want to because the iframe will report the pageView
		return null;
	}
	ProductLineStateHolder.prototype.loaded = function() {
		//*DEBUG*/console.log('ProductLineStateHolder: loaded');

		if (this.state.swatchId === undefined) {
			// Close
			if (productLineSelected !== undefined) {
				if (this.iTurnedOffScrollbars) {
					toggleBodyScrollbar(true);
					this.iTurnedOffScrollbars = false;
				}

				// Trigger event so other code can do things when closing modal
				// (NOTE we trigger on iframe and inside iframe. On iframe isn't seen by anything inside)
				var event = document.createEvent('CustomEvent');
				event.initCustomEvent('closingIFrame', true, true, null);
				iframe.contentWindow.document.dispatchEvent(event);

				$productLineModal.removeClass('productLineModal--open');
				productLineSelected = undefined;

				$(document).off('keyup', escListener);
			}
		} else {
			// Open
			if (productLineSelected !== this.state.swatchId) {
				this.iTurnedOffScrollbars = toggleBodyScrollbar(false);

				var href = currentSwatch.createProductLineURLForSwatchId(this.state.swatchId) + '&iframe=true';
				iframe.contentWindow.document.body.innerHTML = '';
				// Note: we use replace so there isn't a history entry added to the iframe
				href = getAbsoluteUrl(href);
				iframe.contentWindow.location.replace(href);

				$productLineModal.removeClass('productLineModal--loaded');
				$productLineModal.addClass('productLineModal--open');
				productLineSelected = this.state.swatchId;

				$(document).on('keyup', escListener);

				this.hasModalSlideIn = false;
				setTimeout(function() {
					// CSS takes this long to slide in
					this.hasModalSlideIn = true;
				}, 1000);
			}
		}
	}
	ProductLineStateHolder.prototype.open = function(swatchId, save, refresh, rootUrl) {
		//*DEBUG*/console.log('ProductLineStateHolder: open');

		if (save === undefined)
			save = true;
		if (refresh === undefined)
			refresh = true;

		this.state.swatchId = swatchId;

		if (save) {
			StateManager.instance.save(refresh, rootUrl);
		}
	}
	var productLineStateHolder = new ProductLineStateHolder();




	// On click close modal and return to results
	$productLineModal.find('.returnToResults, .productLineModal__overlay').on('click', function(event) {
		event.preventDefault();
		triggerEvent(document, 'returnToResults');
	});
	function escListener(event) {
		if (event.key == 'Escape') {
			triggerEvent(document, 'returnToResults');
		}
	}

	// -----------------
	// Return to Results:
	// Listens for event and does actually closing (note the iframe product line is in may trigger this even too)
	// -----------------
	document.addEventListener('returnToResults', function() {
		/* 2024-05-26: Removed cause this does not sem needed and messing stuff up.

		var isMobile = ViewportTracker.getState() === 'mobile';
		if (isMobile) {
			// On mobile swatch select is a modal so we want to close it
			// (Kind of hackerish but causes colorbox to close without animation)
			try {
				$.colorbox.element().data('colorbox').fadeOut = 0;
			} catch (e) {
				// Can ignore. Happens if switch layout from desktop and the modal for the swatch was never opened.
			}
			currentSwatch.switchTo(undefined);
		}
		*/
		/* 2024-05-24: This didn't look right and didn't do what we needed so switched to history.back().
		productLineStateHolder.open(undefined);
		*/
		window.history.back();
	});


	// -----------------
	// Return to Results:
	// Events triggered by iframe to let us know when scrolled past a point
	// We then move the 'return to results' off the screen slightly
	// -----------------
	document.addEventListener('productLineScrolledDown', function() {
		$productLineModal.addClass('productLineModal--scrolledDown');
	});
	document.addEventListener('productLineScrolledUp', function() {
		$productLineModal.removeClass('productLineModal--scrolledDown');
	});


	// -----------------
	// Product Line: Open in modal
	// -----------------
	$('body').on('click', '.swatch', function(event) {
		// If the user is holding down a modifier key that opens a link in a new window/tab, we let the native browser behavior take place.
		if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
			event.preventDefault();
			var href = this.href;
			var index = href.indexOf('s.id=');
			if (index !== -1) {
				var swatchId = decodeURIComponent(href.substring(index + 5))
				productLineStateHolder.open(swatchId, true, true, href);
			}
		}
	});
}

module.exports = {
	init : function() {
		if ($('.__productCategory').length === 0)
			return;

		setupFilterInterface();
		var currentSwatch = setupSelectSwatch();
		setupProductLine(currentSwatch);
	}
};
